import React from 'react';
import PropTypes from 'prop-types';
import { useImpression } from '@thd-olt-component-react/impression';
import classNames from 'classnames';
import CompactNullView from './CompactNullView';
import DesktopNullView from './DesktopNullView';
import { showAboveSmBreakpoint, showBelowSmBreakpoint } from '../../../constants/responsiveClassNames';

const ListsNullView = ({ componentId }) => {
  const { ref, clickID } = useImpression({
    data: {
      component: 'Lists',
      name: 'ListsNullState',
      id: componentId || '',
      position: 1,
      type: 'content'
    }
  });

  return (
    <div
      className="sui-@container sui-h-full"
      data-testid="lists-null-view"
      ref={ref}
      // eslint-disable-next-line react/no-unknown-property
      clickid={clickID}
    >
      <div
        id="lists-compact-null-view"
        className={classNames(showBelowSmBreakpoint)}
      >
        <CompactNullView
          clickID={clickID}
        />
      </div>
      <div
        id="lists-desktop-null-view"
        className={classNames(showAboveSmBreakpoint, 'sui-h-full')}
      >
        <DesktopNullView />
      </div>
    </div>
  );
};

ListsNullView.propTypes = {
  componentId: PropTypes.string
};

ListsNullView.defaultProps = {
  componentId: ''
};

export default ListsNullView;
